import React, { useEffect, useState } from 'react';
import "./Home.css"
import ApiComponent from './ApiComponent';
import Header from './Header';

function Home ({ userInfo }){
    const authProvider = window.location.hostname === "localhost" ? "local" : "aadb2c";
    const loginUrl = `/.auth/login/${authProvider}`;
    const redirect = window.location.pathname;

    return (
        <>
            <Header userInfo={userInfo} />
            <div className="home"> 
                {userInfo && (
                    <ApiComponent />
                )}

                {!userInfo && (
                    <div className="home-unauth-message">
                        <p>Welcome to the Milrose Customer Portal. You will be able to view project details for any Milrose projects you are associated with.</p>
                        <p>Please <a href={loginUrl}>Sign In</a> to access your project data.</p>
                    </div>
                )}
            </div>
        </>
    )
}

export default Home;